import React, { Fragment, useState, useEffect } from 'react';
import Breadcrumb from "../common/breadcrumb";
import Carousel from '../common/carousel'
import UserCard from '../common/user-card'
import ClimaCard from '../common/clima-card'
import UserCardProx from '../common/user-card-prox'
import { File } from 'react-feather';
/* TIPO DE CAMBIO */
import Buy from '../common/Buy'
import Sell from '../common/Sell'
import Dolar from "../../assets/images/dashboard/dolar.png";
import Climabg from "../../assets/images/clima-back.png";
import capitalhumanobg from "../../assets/images/capitalhumano.png";
/* TIPO DE CAMBIO */

/* ICONOS CLIMA */
import Lluvia from '../common/clima/lluvia'
import Soleado from '../common/clima/soleado'
import Nublado from '../common/clima/nublado'
import ParcialNublado from '../common/clima/parcial-nublado'
import ParcialNubladoLluvia from '../common/clima/parcial-nublado-lluvia'
import Granizo from '../common/clima/granizo'
import Viento from '../common/clima/viento'
import ParcialNubladoGranizo from '../common/clima/parcial-nublado-granizo'
import ParcialNubladoTormenta from '../common/clima/parcial-nublado-tormenta'
import Tormenta from '../common/clima/tormenta'
import Neblina from '../common/clima/neblina'
/* ICONOS CLIMA */

const stripHtml = (html) => {
    if (!html) return '';
    return html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
};

const ComunicadosInicio = (props) => {
    const [carousel_items, setCarousel_items] = useState([]);
    const [comunicados, setComunicados] = useState([]);
    const [comunicados_externos, setComunicados_externos] = useState([]);
    const [mostrar_anteriores, setMostrar_anteriores] = useState(false);
    const [festejados, setFestejados] = useState([]);
    const [festejados_prox, setFestejados_prox] = useState([]);
    const [clima, setClima] = useState({});
    const [sabias_que, setSabias_que] = useState({});
    const [nota, setNota] = useState([]);
    const [capital, setCapital] = useState([]);
    const [ready, setReady] = useState(false);
    const [isMounted, setIsMounted] = useState(true);

    useEffect(() => {
        // Cargar datos principales
        fetch('/z_comunicados_inicio', {
            method: 'PUT',
            body: JSON.stringify({ id: localStorage.getItem('id_usr') }),
            headers: { 'Content-Type': 'application/json' }
        })
            .then(res => res.json())
            .then(res => {
                console.log(res);
                if (res.status == 'OK' && isMounted) {
                    var temp_carrousel = []
                    res.result[0].map((elem) => {
                        temp_carrousel.push({
                            redirect: () => { props.history.push('/publicacion/' + elem.ID) },
                            src: `/z_publicaciones?img=${elem.ID + elem.IMAGEN}`,
                            altText: elem.TITULO,
                            captionHeader: elem.TITULO,
                            captionText: elem.FECHA,
                            onError: (e) => { e.target.src = "https://terancomunicados.com/assets/images/banner.png" }
                        })
                    })
                    setCarousel_items(temp_carrousel)
                    setFestejados(res.result[1])
                    setClima(res.result[2][0])
                    setSabias_que(res.result[3][0])
                    setNota(res.result[4])
                    setFestejados_prox(res.result[5])
                    setCapital(res.result[6])
                    setReady(true)
                } else {
                    console.log('Error interno');
                }
            })
            .catch(err => {
                console.log('Error:', err);
            })

        // Cargar comunicados externos del día
        fetch('/z_comunicados_externos_hoy', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        })
            .then(res => res.json())
            .then(res => {
                console.log('Comunicados externos:', res);
                if (res.status === 1 && isMounted) {
                    setComunicados_externos(res.result || []);
                } else {
                    console.log('Error al cargar comunicados externos');
                    if (isMounted) setComunicados_externos([]);
                }
            })
            .catch(err => {
                console.log('Error:', err);
                if (isMounted) setComunicados_externos([]);
            })

        return () => {
            setIsMounted(false);
        };
    }, []);

    const cargarComunicadosAnteriores = () => {
        fetch('/z_comunicados_externos_recientes', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        })
            .then(res => res.json())
            .then(res => {
                console.log('Comunicados anteriores:', res);
                if (res.status === 1 && isMounted) {
                    setComunicados_externos(res.result || []);
                    setMostrar_anteriores(true);
                } else {
                    console.log('Error al cargar comunicados anteriores');
                }
            })
            .catch(err => {
                console.log('Error:', err);
            })
    };

    const Clima = (c) => {
        if (c === 'Clouds')
            return <ParcialNublado />
        else if (c === 'Clear')
            return <Soleado />
        else if (c === 'Rain')
            return <Lluvia />
        else if (c === 'Drizzle')
            return <Lluvia />
        else if (c === 'Snow')
            return <Granizo />
        else if (c === 'Thunderstorm')
            return <Tormenta />
        else if (c === 'Atmosphere')
            return <Neblina />
        else
            return <Soleado />
    }

    return (
        <Fragment>
            <Breadcrumb title="Página principal" parent="Comunicados" />
            <div className="container-fluid">
                {ready ?
                    <div className="row">
                        <div className="col-12 col-lg-8">
                            <div className="row mb-4">
                                <div className="col-12">
                                    <Carousel items={carousel_items} />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card comunicados">
                                        <div className="card-body">
                                            <h3 className="title-widget f-w-600 mb-0">Comunicados</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12">
                                    <div className="card container">
                                        <div id="blog-post" className="row">
                                            {comunicados_externos.length > 0 ? (
                                                <>
                                                    {mostrar_anteriores && (
                                                        <div className="col-12 mb-3">
                                                            <div className="alert alert-info text-center" role="alert">
                                                                <strong>Mostrando los últimos 4 comunicados</strong>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {comunicados_externos.map((comunicado) => {
                                                        const fecha = new Date(comunicado.FECHA_COMUNICADO);
                                                        const dia = fecha.getDate().toString().padStart(2, '0');
                                                        const meses = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
                                                        const mes = meses[fecha.getMonth()];
                                                        
                                                        return (
                                                            <div key={comunicado.ID_COMUNICADO} className="col-lg-6 col-md-6 col-12 blog-post mb-3">
                                                                <div style={{ marginBottom: '30px', border: '1px solid #e5e5e5', borderRadius: '10px', overflow: 'hidden', marginTop: '30px' }}>
                                                                    <div className="blog-image" style={{ position: 'relative' }}>
                                                                        <a href={`/comunicado/${comunicado.SLUG || comunicado.ID_COMUNICADO}`} style={{ cursor: 'pointer' }}>
                                                                            <img 
                                                                                src={`https://comunicados.joseluisteran.com/comunicados/${comunicado.ID_COMUNICADO}/portada.jpg`}
                                                                                className="card-img-top" 
                                                                                alt={comunicado.TITULO_COMUNICADO}
                                                                                onError={(e) => { e.target.src = "https://terancomunicados.com/assets/images/banner.png" }} 
                                                                            />
                                                                        </a>
                                                                        <ul style={{ position: 'absolute', left: '10px', top: '10px', outline: '2px solid #fff', outlineOffset: '3px', height: '60px', width: '50px', textAlign: 'center', background: '#fff', padding: '8px 0px', }}>
                                                                            <li style={{ color: '#ff6a00', fontWeight: '800', fontSize: '18px' }}>{dia}</li>
                                                                            <li style={{ fontSize: '12px', fontWeight: '600' }}>{mes}</li>
                                                                        </ul>
                                                                    </div>
                                                                    <div style={{ padding: '30px 20px', minHeight: (comunicado.INTRODUCCION_COMUNICADO || comunicado.DESCRIPCION_COMUNICADO) ? '250px' : 'unset' }}>
                                                                        <h3 className="title-clamp" style={{ overflow: "hidden", textOverflow: "ellipsis", WebkitBoxOrient: "vertical", display: "-webkit-box", WebkitLineClamp: 2 }}>
                                                                            <a href={`/comunicado/${comunicado.SLUG || comunicado.ID_COMUNICADO}`} style={{ cursor: 'pointer' }}>
                                                                                {comunicado.TITULO_COMUNICADO}
                                                                            </a>
                                                                        </h3>
                                                                        {(comunicado.INTRODUCCION_COMUNICADO || comunicado.DESCRIPCION_COMUNICADO) && (
                                                                            <p className="description-clamp" style={{ overflow: "hidden", textOverflow: "ellipsis", WebkitBoxOrient: "vertical", display: "-webkit-box", WebkitLineClamp: 3 }}>
                                                                                {stripHtml(comunicado.INTRODUCCION_COMUNICADO || comunicado.DESCRIPCION_COMUNICADO)}
                                                                            </p>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </>
                                            ) : (
                                                <div className="col-12 text-center py-5">
                                                    <h5 className="text-muted mb-4">No hay comunicados del día</h5>
                                                    {!mostrar_anteriores && (
                                                        <button 
                                                            className="btn btn-vest btn-primary"
                                                            onClick={cargarComunicadosAnteriores}
                                                            style={{ backgroundColor: '#ff6a00', borderColor: '#ff6a00' }}
                                                        >
                                                            <span>Mostrar comunicados anteriores <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 13.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-eye"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" /><path d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6" /></svg></span>
                                                        </button>
                                                    )}
                                                </div>
                                            )}
                                        </div>

                                        <div className="blog row justify-content-center">
                                            {/* {!!comunicados.length ?
												comunicados.map(elem => {
													return <div key={elem.ID} className="blog-box blog-list col-12 col-lg-6">
														<a href={'/comunicados/comunicado/' + elem.ID}>
															<div className="blog-date digits">{elem.FECHA_PUBLICACION}</div>
															<h6><File className="mr-2" size={18} color="#c1452c" /> {elem.TITULO}</h6>
															<div className="blog-bottom-content">
																<ul className="blog-social">
																	<li>Por {elem.REMITENTE}</li>
																</ul>
																<p className="my-3">{elem.DESCRIPCION.substr(0, 100) + '...'}</p>
															</div>
														</a>
													</div>
												})
												:
												<h5 className="text-center p-3 mb-0">No hay comunicados recientes</h5>
											} */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-lg-4">
                            <div className="row">
                                {
                                    (!!festejados.length || !!festejados_prox.length) &&
                                    <div className="col-12 col-md-12 mt-2">{/* Cumpleaños */}
                                        <div>
                                            <div className="card custom-card birthday-card">
                                                {!!festejados.length && <UserCard user_data={festejados} />}
                                                {
                                                    !!festejados_prox.length &&
                                                    <Fragment>
                                                        <div className="card-proximos" style={{ marginTop: '40%' }}>
                                                            {/* <h4 className="text-center font-weight-bold pb-xl-5 pt-2">Próximos cumpleaños</h4> */}
                                                            <UserCardProx user_data={festejados_prox} />
                                                        </div>
                                                    </Fragment>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div className="col-12">
                                    <div className="card" style={{ backgroundImage: "url(" + Climabg + ")", backgroundSize: 'contain', backgroundPosition: 'right', backgroundRepeat: 'no-repeat' }}>
                                        <ClimaCard user_data={clima} Clima={Clima} />
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="card testimonial text-center cambio" style={{ cursor: 'pointer' }} onClick={() => { sabias_que?.ID && window.location.replace(`/sabias_que/${sabias_que.ID}`) }}>
                                        <div className="card-body">
                                            <h3 className="title-widget f-w-600">¿Sabías qué... ?</h3>
                                            <p className="f-16">{sabias_que?.TITULO || '-'}</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-6 col-md-6 col-xl-6 set-col-6">
                                    <Buy />
                                </div>
                                <div className="col-6 col-md-6 col-xl-6 set-col-6">
                                    <Sell />
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 col-sm-12">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card notas">
                                        <div className="card-body" onClick={() => { window.location.replace(`/notascotidianas`) }} style={{ cursor: 'pointer' }}>
                                            <h3 className="title-widget f-w-600 mb-0 text-md-center">Notas Cotidianas</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                {nota.map((x) => {
                                    return <div key={x.ID} className="col-md-12 col-xl-12 set-col-12">
                                        <div className="card">
                                            <div className="blog-box blog-list row">
                                                <div className="col-sm-5">
                                                    <img className="img-fluid sm-100-w" src={x.PORTADA} alt="" />
                                                </div>
                                                <div className="col-sm-7">
                                                    <div className="blog-details">
                                                        <div className="blog-date digits"><p className="font-weight-bold">{x.FECHA}</p></div>
                                                        <div className="blog-bottom-content no-none">
                                                            <hr />
                                                            <h6 className="mt-0">{x.TITULO}</h6>
                                                            <button className="btn btn-pill btn-sm btn-warning mb-4" type="button" onClick={() => { window.location.replace(`/notas_cotidianas/${x.ID}`) }}>Leer Nota</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                })}
                            </div>
                        </div>
                        <div className="col-md-6 col-sm-12">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card" style={{ backgroundImage: "url(" + capitalhumanobg + ")", backgroundSize: 'auto 100%', backgroundPosition: 'center right', backgroundRepeat: 'no-repeat' }}>
                                        <div className="card-body">
                                            <h3 className="title-widget f-w-600 mb-0 text-md-center">Capital Humano</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                {capital.map((x) => {
                                    return <div key={x.ID} className="col-md-12 col-xl-12 set-col-12">
                                        <div className="card">
                                            <div className="blog-box blog-list row">
                                                <div className="col-sm-5">
                                                    <img className="img-fluid sm-100-w" src={`/z_capital_humano_portada?ID=${x.ID}&PORTADA=${x.PORTADA != '' ? x.PORTADA : 'no-img'}`} alt="" />
                                                </div>
                                                <div className="col-sm-7">
                                                    <div className="blog-details">
                                                        <div className="blog-date digits"><p className="font-weight-bold">{x.FECHA}</p></div>
                                                        <div className="blog-bottom-content no-none">
                                                            <hr />
                                                            <h6 className="mt-0">{x.TITULO}</h6>
                                                            <button className="btn btn-pill btn-sm btn-warning mb-4" type="button" onClick={() => { window.location.replace(`/capitalhumano/nota/${x.ID}`) }}>Leer Nota</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                })}
                            </div>
                        </div>
                    </div>
                    :
                    <div className="d-flex justify-content-center align-items-center">
                        <div className="loader-box mr-4">
                            <div className="loader">
                                <div className="line bg-warning"></div>
                                <div className="line bg-warning"></div>
                                <div className="line bg-warning"></div>
                                <div className="line bg-warning"></div>
                            </div>
                        </div>
                        <h5 className="text-uppercase">Cargando...</h5>
                    </div>
                }
            </div>
        </Fragment>
    );
}

export default ComunicadosInicio;
